import { Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import PainelAdmin from "./PainelAdmin";
import ProtectedRoute from "./ProtectedRoute";
import ComprovantePagamento from "./pages/ComprovantePagamento";
import PagamentoConfirm from "./PagamentoConfirm";
import PixPayment from "./pages/PixPayment";
import ValidandoPagamento from "./pages/validando-pagamento";

export default function App() {
  const token = localStorage.getItem("token");

  return (
    <Routes>
      {/* Rota de login SEM proteção */}
      <Route path="/login" element={<Login />} />

      {/* Rota raiz redireciona dependendo do token */}
      <Route
        path="/"
        element={
          token ? <Navigate to="/painel" replace /> : <Navigate to="/login" replace />
        }
      />

      {/* Rota protegida do painel */}
      <Route
        path="/painel"
        element={
          <ProtectedRoute>
            <PainelAdmin />
          </ProtectedRoute>
        }
      />

      {/* Páginas públicas para pagamento */}
      <Route path="/pagamento" element={<ComprovantePagamento />} />
      <Route path="/pagamento/:id" element={<PagamentoConfirm />} />
      <Route path="/comprovante" element={<ComprovantePagamento />} />
      <Route path="/pix/:id" element={<PixPayment />} />
      <Route path="/validando" element={<ValidandoPagamento />} />
    </Routes>
  );
}
